<template>
  <b-row>
    <!-- Group Type -->
    <b-col cols="12" md="3" class="mb-md-0 mb-2">
      <label>Group Type</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="groupTypeFilter"
        :options="groupTypeOptions"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:group-type-filter', val)"
        placeholder="Select Group Type"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue';
import vSelect from 'vue-select';

export default {
  name: 'ItemGroupListFilters',
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    groupTypeFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      groupTypeOptions: [
        { value: null, label: 'All' },
        { value: 'C', label: 'Control' },
        { value: 'D', label: 'Detail' },
      ],
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
